export function normalizeFacetGroup(value) {
  if (!value) return [];

  if (Array.isArray(value)) {
    if (value.length > 0 && Array.isArray(value[0])) {
      return value
        .map((pair) => ({
          key: String(pair?.[0] ?? ''),
          label: String(pair?.[0] ?? ''),
          count: Number(pair?.[1] ?? 0),
        }))
        .filter((opt) => opt.key.length > 0);
    }

    return value
      .map((item) => {
        const key = item?.value ?? item?.id ?? item?.name ?? item?.label ?? '';
        const label = item?.label ?? item?.name ?? item?.value ?? key ?? '';
        return {
          key: String(key),
          label: String(label),
          count: Number(item?.count ?? 0),
        };
      })
      .filter((opt) => opt.key.length > 0);
  }

  if (typeof value === 'object') {
    return Object.entries(value)
      .map(([label, count]) => ({
        key: String(label),
        label: String(label),
        count: Number(count ?? 0),
      }))
      .filter((opt) => opt.key.length > 0);
  }

  return [];
}
